import { Button, Stack, TextField, Typography } from '@mui/material';
import { useFirebase } from 'contexts/FirebaseContext';
import { sendPasswordResetEmail } from 'firebase/auth';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { validateEmail } from 'utils/validateEmail';

export interface ResetPasswordProps {
  email?: string;
  onSuccess?: (email: string) => void;
}

export function ResetPassword(props: ResetPasswordProps) {
  const { t } = useTranslation();
  const [email, setEmail] = useState(props.email || '');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const auth = useFirebase().auth;

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);

    if (email) {
      sendPasswordResetEmail(auth, email).then(() => {
        setIsLoading(false);
        setIsSuccess(true);
        props.onSuccess?.(email);
      });
    }
  };

  const handleChangeEmail = (value: string) => {
    setEmail(value);

    if (value == '' || validateEmail(value)) {
      setErrorMessage('');
    } else {
      setErrorMessage('Invalid email address');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={1}>
        <TextField
          type="email"
          label="Email"
          value={email}
          error={email != '' && !!errorMessage}
          helperText={errorMessage}
          onChange={(event) => handleChangeEmail(event.target.value)}
        />
        <Button
          loading={isLoading}
          type="submit"
          variant="contained"
          disabled={!email || !!errorMessage}
        >
          {t('resetPassword', 'Reset password')}
        </Button>
        {isSuccess && (
          <Typography color="success" sx={{ textAlign: 'center' }}>
            {t(
              'passwordResetNotification',
              'A password reset link has been sent to your email. Please check your inbox.'
            )}
          </Typography>
        )}
      </Stack>
    </form>
  );
}
